import { useAuthStore } from '@/stores/auth';

/**
 * Story 29.5 — WhatsApp access gate signal. Reads the admin-controlled `whatsappEnabled` flag and
 * the pending-request marker straight off the persisted auth user (returned by /auth/me), so no
 * extra polling/fetch is needed.
 */
export function useWhatsAppAccess(): { enabled: boolean; alreadyRequested: boolean } {
  const tenant = useAuthStore((s) => s.user?.tenant);
  const settings = (tenant?.settings ?? {}) as Record<string, unknown>;
  return {
    enabled: tenant?.whatsappEnabled === true,
    alreadyRequested: typeof settings.whatsappAccessRequestedAt === 'string',
  };
}
